import { render } from "./TravelGuide.vue?vue&type=template&id=79c96270&scoped=true"
import script from "./TravelGuide.vue?vue&type=script&lang=js"
export * from "./TravelGuide.vue?vue&type=script&lang=js"

import "./TravelGuide.vue?vue&type=style&index=0&id=79c96270&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c96270"]])

export default __exports__